export default __webpack_public_path__ + "static/Montserrat-600-0480d2f8a71f38db8633b84d8722e0c2.woff2";